export default __webpack_public_path__ + "static/media/wave.56be9a55.png";